import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog-box',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirm-dialog-box.component.html',
  styleUrl: './confirm-dialog-box.component.scss'
})
export class ConfirmDialogBoxComponent {
constructor(@Inject(MAT_DIALOG_DATA) public data: {message: string}) { }
}
